import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import WidgetSquarePlaceholder from './WidgetSquarePlaceholder';
import { purchaseRequestService } from 'features/inventory/purchase-requests/api/purchase-request.service';

function PurchaseRequestsAutomatic() {
  const { t } = useTranslation();
  const [counter, setCounter] = useState(undefined);

  useEffect(() => {
    purchaseRequestService
      .getAllPaginated(1, 0, { automatic_generated: true, status: 'NEW' })
      .then((res) => setCounter(res.count));
  }, []);

  return counter !== undefined ? (
    <div className="w-full flex flex-col justify-center items-center px-1">
      {counter > 0 && (
        <>
          <KeyboardDoubleArrowRightIcon fontSize="large" color="warning" />
          <span className="text-center">
            {t(`dashboard.purchase_requests-automatic.body-error`)}
          </span>
          <NavLink to={'/tenant/purchase_requests/automatic?blameMode=true'}>
            <Button color="warning">{t(`dashboard.purchase_requests-automatic.go`)}</Button>
          </NavLink>
        </>
      )}
      {counter === 0 && (
        <>
          <KeyboardDoubleArrowRightIcon fontSize="large" color="success" />
          <span className="text-center">
            {t(`dashboard.purchase_requests-automatic.body-success`)}
          </span>
        </>
      )}
    </div>
  ) : (
    <>
      {counter}
      <WidgetSquarePlaceholder />
    </>
  );
}

export default PurchaseRequestsAutomatic;
